import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouteInfo } from './vertical-sidebar.metadata';
import { VerticalSidebarService } from './vertical-sidebar.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from 'src/app/services/storage.service';
import { ModalMaterialesEstandarComponent } from '../modals/modal-materiales-estandar/modal-materiales-estandar.component';
import { MdArticuloNuevoComponent } from '../modals/md-articulo-nuevo/md-articulo-nuevo.component';
import { MdProveedorNuevoComponent } from '../modals/md-proveedor-nuevo/md-proveedor-nuevo.component';
import { MdClienteNuevoComponent } from '../modals/md-cliente-nuevo/md-cliente-nuevo.component';
import { environment } from 'src/environments/environment';
import { MdEstadoCuentaComponent } from 'src/app/shared/modals/md-estado-cuenta/md-estado-cuenta.component';
import { MdEstadoCuentaProveedorComponent } from 'src/app/shared/modals/md-estado-cuenta-proveedor/md-estado-cuenta-proveedor.component';

declare var $: any;

@Component({
  selector: 'app-vertical-sidebar',
  templateUrl: './vertical-sidebar.component.html'
})
export class VerticalSidebarComponent implements OnInit{
  showMenu = '';
  showSubMenu = '';
  public sidebarnavItems: RouteInfo[] = [];
  path = '';

  public sessionInfo: any = {};


  @Input() showClass: boolean = false;
  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();


  handleNotify() {
    this.notify.emit(!this.showClass);
  }

  constructor(
    private menuServise: VerticalSidebarService,
    private router: Router,
    private modalService: NgbModal,
    ) {
    this.menuServise.items.subscribe(menuItems => {
      this.sidebarnavItems = menuItems;

      // Active menu
      this.sidebarnavItems.filter(m => m.submenu.filter(
        (s) => {
          if (s.path === this.router.url) {
            this.path = m.title;
          }
        }
      ));
      this.addExpandClass(this.path);
    });
  }

  ngOnInit(): void {
    this.sessionInfo = JSON.parse(StorageService.getSession());
  }

  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }

  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }


    //!IMPORTANTE PRIMERO IMPORTAR EL MODAL A ESTE COMPONENTE
    openModal(namemodal: any) {
      console.log("ABRIENDO MODAL")
      switch (namemodal) {
        case "ModalMaterialesEstandarComponent":
          this.modalService.open(ModalMaterialesEstandarComponent, { scrollable: true, windowClass: 'md-full-size', backdrop: 'static' });
          break;
  
        case "MdArticuloNuevoComponent":
          this.modalService.open(MdArticuloNuevoComponent, { scrollable: true, windowClass: 'md-full-size', backdrop: 'static' });
          break;
  
        case "MdProveedorNuevoComponent":
          this.modalService.open(MdProveedorNuevoComponent, { scrollable: true, windowClass: 'md-full-size', backdrop: 'static' });
          break;
  
        case "MdClienteNuevoComponent":
          this.modalService.open(MdClienteNuevoComponent, { scrollable: true, windowClass: 'md-full-size', backdrop: 'static' });
        break;
        case "MdCobrarEECC":
          this.modalService.open(MdEstadoCuentaComponent, { scrollable: true, windowClass: 'md-full-size', backdrop: 'static' });
        break;
        case "MdPagarEECC":
        this.modalService.open(MdEstadoCuentaProveedorComponent, { scrollable: true, windowClass: 'md-full-size', backdrop: 'static' });
      break;
        default:
  
          break;
      }
    }
}
